import { render } from "./BannerDefaultStatisticSectionCmp.vue?vue&type=template&id=1ea385a8"
import script from "./BannerDefaultStatisticSectionCmp.vue?vue&type=script&lang=js"
export * from "./BannerDefaultStatisticSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__